<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";
import { ModelSelect } from 'vue-search-select';
import VueSweetalert2 from "vue-sweetalert2";
export default {
  components: { ErrorMessage, Layout, PageHeader , ModelSelect,},
  data() {
    return {
      title: "Deposit List",
      items: [
        {
          text: "Deposit",
          href: "/",
        },
        {
          text: "Deposit List",
          active: true,
        },
      ],
      vendors: [],
      admins: [],
        display_div:true,
        alladmins:[],
      errors: null,
      pin: "",
      deposits: [],
      deposit: [],
      user_id: "",
        user_type:"",
      startdate: "",
      enddate: "",
      deposit_status: "",
      remarks: "",
        visible:false,
        message:"",
        booking_status:"",
      search_utype:"",
      search_fname:"",
      search_lname:"",
        search_uname:"",
      search_dtype:"",
      search_amount:"",
      search_ref:"",
      search_bank:"",
      search_branch:"",
    };
  },
    created() {
        let deposit_status = this.$route.params.status;
        if(deposit_status=="pending"){
            this.deposit_status=2;
            this.search();
        }
    },
  mounted() {
    this.getAdminList();
    this.search();
  },
  computed: {
        filteredList() {
            return this.deposits.filter(deposit => {
                return (deposit.users.username==null ? '' : deposit.users.username).toLowerCase().includes(this.search_uname.toLowerCase())
                    && deposit.ref_no.toLowerCase().includes(this.search_ref.toLowerCase())

            })
        }
    },
  methods: {
      onClose(){
          this.visible=false;
      },
      toggleDiv: function() {
          this.display_div = !this.display_div;
      },
    async getAdminList() {
      try {
        axios
          .get("/api/user/approved/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
                let temp=response.data.data;
                let i;
                let arr=[];
                for (i=0;i<temp.length;i++){
                    if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                        if(temp[i].approved_agents[0].approval_status=='approved') {
                            temp[i].value = temp[i].id;
                            temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                            arr.push(temp[i]);
                        }
                    }
                    if(temp[i].account_type=='b2c'){
                        if(temp[i].first_name==null){
                            temp[i].text=temp[i].email + '(unregistered)';
                        }else{
                            temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                        }
                        temp[i].value = temp[i].id;
                        arr.push(temp[i]);
                    }

                }
                this.alladmins=arr;
                this.admins = arr;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async approvedDeposit(deposit) {
      var _this = this;

      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          html:
            '<input id="swal-input1" type="password" class="swal2-input" placeholder="Enter your pin">' +
            '<input id="swal-input2" class="swal2-input" placeholder="Type your note">',
          preConfirm: function () {
            return new Promise(function (resolve) {
              resolve([$("#swal-input1").val(), $("#swal-input2").val()]);
            });
          },
          onOpen: function () {
            $("#swal-input1").focus();
          },
        })
          .then(function (result) {
            if (
              result.isConfirmed &&
              result.value[0] != "" &&
              result.value[1] != ""
            ) {
              _this.pin = result.value[0];
              _this.remarks = "Ar:"+result.value[1]+" Cr:"+deposit.remarks;
              _this.approve(deposit.id);
            } else {
              _this.$swal("Cancelled", "Deposit is still intact", "info");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async denyDeposit(deposit) {
      var _this = this;

      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          html:
            '<input id="swal-input1" type="password" class="swal2-input" placeholder="Enter your pin">' +
            '<input id="swal-input2" class="swal2-input" placeholder="Type your note">',
          preConfirm: function () {
            return new Promise(function (resolve) {
              resolve([$("#swal-input1").val(), $("#swal-input2").val()]);
            });
          },
          onOpen: function () {
            $("#swal-input1").focus();
          },
        })
          .then(function (result) {
            if (
              result.isConfirmed &&
              result.value[0] != "" &&
              result.value[1] != ""
            ) {
              _this.pin = result.value[0];
              _this.remarks = "Ar:"+result.value[1]+" Cr:"+deposit.remarks;
              _this.deny(deposit.id);
            } else {
              _this.$swal("Cancelled", "Deposit is still intact", "info");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async approve(id) {
      var _this = this;
      try {
        axios
          .post("/api/deposit/approve", {
            accessToken: localStorage.getItem("access_tocken"),
            deposit_id: id,
            pin: this.pin,
            remarks: this.remarks,
          })
          .then((response) => {
            if (response.data.status) {
              _this.$swal("Success", "Approved", "success");
              _this.search();
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            if (error.response != undefined) {
              this.$swal("Error", "PIN doesn't match", "error");
            }
          });
      } catch (err) {
        console.log(err);
      }
    },
    async deny(id) {
      var _this = this;
      try {
        axios
          .post("/api/deposit/deny", {
            accessToken: localStorage.getItem("access_tocken"),
            deposit_id: id,
            pin: this.pin,
            remarks: this.remarks,
          })
          .then((response) => {
            if (response.data.status) {
              _this.$swal("Success", "Deny", "success");
              _this.search();
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            if (error.response != undefined) {
              this.$swal("Error", "PIN doesn't match", "error");
            }
          });
      } catch (err) {
        console.log(err);
      }
    },
    async search() {
      try {
        axios
          .get("/api/deposit/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
              user_id: this.user_id,
              startdate: this.startdate,
              enddate: this.enddate,
              status: this.deposit_status,
                user_type:this.user_type
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.deposits = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
      async clear() {
          this.user_type="";
              this.startdate="";
              this.enddate="";
              this.deposit_status="";
              this.user_id="";
              this.admins=this.alladmins;
      },
      onChange(event) {
          this.user_type=event.target.value;
          var temp=this.alladmins;
          var arr=[];
          var i;
          for (i=0;i<temp.length;i++){
              if (temp[i].account_type==event.target.value){
                  arr.push(temp[i]);
              }
          }
          this.admins = arr;
      },
    errorCheck(obj) {
        if(obj.message=='need to create PIN first'){
            this.$swal("Error", "need to create PIN first", "error");
        }
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.$swal("Error", obj.message, "error");
        this.search();
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <b-button class='float-right' v-if="display_div" v-on:click="toggleDiv()" size="sm">Collapse</b-button>
              <b-button class='float-right' v-else v-on:click="toggleDiv()" size="sm">Expand</b-button>
            <div v-if="errors" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
              <h4 class="card-title">Deposit List</h4>
            <div v-if="display_div" class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="user_type">Select User Type</label>
                        <select
                            id="user_type"
                            name="user_type"
                            v-model="user_type"
                            @change="onChange($event)"
                            class="form-control"
                            placeholder="Select User Type">
                            <option value="b2b">B2B
                            </option>
                            <option value="b2c">B2C
                            </option>
                        </select>
                    </div>
                </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Select User</label>
                    <model-select :options="admins"
                                  v-model="user_id"
                                  placeholder="Select User">
                    </model-select>
<!--                  <select-->
<!--                    id="user_id"-->
<!--                    name="user_id"-->
<!--                    v-model="user_id"-->
<!--                    class="form-control"-->
<!--                    placeholder="Type Select User">-->
<!--                    <option v-for="(admin, index) in admins" :value="admin.id" v-if="admin.account_type == user_type"-->
<!--                          v-bind:key="index">{{ admin.first_name+' '+admin.last_name }}-->
<!--                  </option>-->
<!--                  </select>-->
                </div>
              </div>
                <div class="col-md-4">
                    <div>
                        <label for="deposit_status">Status</label>
                        <select
                            id="deposit_status"
                            name="deposit_status"
                            v-model="deposit_status"
                            class="form-control"
                            placeholder="Type Select deposit_status">
                            <option value="2">Pending</option>
                            <option value="1">Approved</option>
                            <option value="0">Denied</option>
                        </select>
                    </div>
                </div>
              <div class="col-md-4">
                <div>
                  <label>Start Date</label>
                  <b-form-datepicker id="start-datepicker" v-model="startdate" class="mb-2"></b-form-datepicker>
                </div>
              </div>
              <div class="col-md-4">
                <div>
                  <label>End Date</label>
                  <b-form-datepicker id="end-datepicker" v-model="enddate" class="mb-2"></b-form-datepicker>
                </div>
              </div>

                <div class="col-md-12 text-center"><span><button class="btn btn-primary" @click.prevent="search()">Search</button></span><span><button class="btn btn-light" @click.prevent="clear()">Clear</button></span></div>


            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Deposit List</h4>
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                      <th>Deposit Date</th>
                      <th>User</th>
                      <th>Ref. No.</th>
                      <th>Deposit Type/Method</th>
<!--                      <th>Username</th>-->
<!--                      <th>First Name</th>-->
<!--                      <th>Last Name</th>-->
                    <th>Amount</th>
                      <th>remarks</th>

                    <th>
                        <div class="row">
                            <div class="col-xs-4">Branch/</div>
                        </div>
                        <div class="row">
                            <div class="col-xs-4">Bank/</div>
                        </div>
                        <div class="row">
                            <div class="col-xs-4">Attachment</div>
                        </div>
                    </th>

                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                  <tr>
                    <td> &nbsp </td>
                      <td> &nbsp </td>
                    <td><input type="text" class="app-search form-control" v-model="search_uname" placeholder="Search username " /></td>
                    <td><input type="text" class="app-search form-control" v-model="search_ref" placeholder="Search ref" /></td>
<!--                    <td><input type="text" class="app-search form-control" v-model="search_lname" placeholder="Search " /></td>-->
<!--                      <td> &nbsp </td>-->
<!--                    <td><input type="text" class="app-search form-control" v-model="search_amount" placeholder="Search " /></td>-->
<!--                    <td><input type="text" class="app-search form-control" v-model="search_ref" placeholder="Search " /></td>-->
                    <!-- <td><input type="text" class="app-search form-control" v-model="search_bank" placeholder="Search " /></td>
                    <td><input type="text" class="app-search form-control" v-model="search_branch" placeholder="Search " /></td> -->

                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(deposit,index) in filteredList" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                      <td>{{deposit.deposit_date==null?'N/A':deposit.deposit_date | moment("D MMM YYYY")}}</td>
                      <td v-if="deposit.users!=null">
                          <div v-if="deposit.account_type==='b2b'"  class="row">
                              <div  class="col-xs-4">{{deposit.agency_name}}</div>
                          </div>
                          <div v-if="deposit.account_type==='b2c'"  class="row">
                              <div  class="col-xs-4">{{deposit.users.first_name+" "+deposit.users.last_name+"("+deposit.users.account_type+")"}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4"><router-link  :to="{ name: 'admin_agent_details', params: {id: deposit.users.id } }" target="_blank" >{{deposit.users.username==null ? 'N/A' : deposit.users.username}}</router-link></div>
                          </div>
                      </td>
                      <td v-else>No User</td>

                      <td>{{deposit.ref_no==null?'N/A':deposit.ref_no}}</td>
                      <td>
                          <div class="row">
                              <div  class="col-xs-4">{{deposit.deposit_type==null?'N/A': deposit.deposit_type}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{deposit.deposit_method=null?'N/A':deposit.deposit_method}}</div>
                          </div>
                      </td>
<!--                      <td>{{deposit.deposit_type==null?'N/A': deposit.deposit_type}}</td>-->
<!--                      <td>{{deposit.deposit_method=null?'N/A':deposit.deposit_method}}</td>-->
<!--                      <td v-if="deposit.users!=null">{{deposit.users.account_type}}</td>-->
<!--                      <td v-else>No user</td>-->
<!--                      <td v-if="deposit.users!=null"><router-link  :to="{ name: 'agent_user_details', params: {id: deposit.users.id } }" target="_blank" >{{deposit.users.username==null ? 'N/A' : deposit.users.username}}</router-link></td>-->
<!--                      <td v-else>N/A</td>-->
<!--                      <td v-if="deposit.users!=null">{{deposit.users.first_name}}</td>-->
<!--                      <td v-else>No user</td>-->
<!--                      <td v-if="deposit.users!=null">{{deposit.users.last_name}}</td>-->
<!--                      <td v-else>No user</td>-->


                    <td><b-badge variant="info">{{deposit.amount}}</b-badge></td>
                      <td>{{deposit.remarks==null?'N/A':deposit.remarks}}</td>
                      <td>
                          <div class="row">
                              <div  class="col-xs-4">{{deposit.branch==null?'N/A':deposit.branch}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{deposit.bank==null?'N/A':deposit.bank}}</div>
                          </div>
                          <div class="row">
                              <div  v-if="deposit.attachment!=null" class="col-xs-4"><a :href="deposit.attachment" download target="_blank">Download</a></div>
                              <div v-else>N/A</div>
                          </div>
                      </td>
                    <td>
                      <p v-if="deposit.is_approved === 1"><b-badge variant="success">Approved</b-badge></p>
                      <p v-else-if="deposit.is_approved === 0"><b-badge variant="danger">Denied</b-badge></p>
                      <p v-else ><b-badge variant="warning">Need Action </b-badge></p>
                    </td>
                    <td>
                      <button v-if="deposit.is_approved == 2" @click.prevent="approvedDeposit(deposit)" class="btn btn-success btn-sm"> Approve</button>
                      <button v-if="deposit.is_approved == 2" @click.prevent="denyDeposit(deposit)" class="btn btn-danger btn-sm"> Deny</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style>
.dropdown-menu.show {
    display: block;
    z-index: 10003;
}
</style>
